module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0BAMAAAA3VgbYAAAALVBMVEVHcEwZivwZivsaivofkv8aivsZivsZivocjf8ZivsbjP0aivsaivwZivsZifrkec/7AAAADnRSTlMAjuXiDb6n1yD0M2hLfcfEz7wAAADYSURBVDjLY2CgFDC/e6cwKjUEpHgT0KTYLsCk5J46oEixxD2Eyri+e1eBItX+7l0IRCru3btHC5CkuPTevXvKAFP0bg6S1Ml3UGNARgPZG+BS3EAexHIgcANy3sKl7gF5KXDXywF5CVApNiD7IcJjEDPAUjDT4QBsM1gK5iY4ALn30WKgFJixACWsQIonAaWQHA4DYCvevdNGdjgDkgfevZuH4nBkD7xDdTiyB96hORzZA2gOR/YAusORPVCBPW0APYDhcIQHUnBmdEGGoQUEcQKGdzgBPaUA9/kzG0JNSgcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/ic_xiazai@2x.png
// module id = Lg+w
// module chunks = 1